import styled from 'styled-components'

export const CatalogItemTagLogoStyled = styled.img`
  display: block;
  flex-shrink: 0;
  width: auto;
  height: ${(props) => props.theme.typography.pxToRem(16)};
`
